import { getModuleTranslator } from '@utils/get-module-translator'
import { generateId } from '@utils/id'
import moduleConfig from '../../config'

const __mtc = getModuleTranslator(moduleConfig.translationKey)

export const storagePoolTabPropertyFieldMap = () => ({
  storage_pool: {
    title: __mtc('storage_pool'),
    fields: [
      {
        key: generateId(),
        paramName: 'name',
        name: __mtc('name'),
        inputType: 'text',
      },
      {
        key: generateId(),
        paramName: 'poolId',
        name: __mtc('pool_id'),
        inputType: 'text',
      },
      {
        key: generateId(),
        paramName: 'uuid',
        name: __mtc('uuid'),
        inputType: 'text',
      },
      {
        key: generateId(),
        paramName: 'size',
        name: __mtc('size'),
        inputType: 'bytes',
      },
    ],
  },
})
